import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExpirationSelectorComponent} from './expiration-selector.component';
import {DevExtremeModule} from "../devextreme.module";

@NgModule({
    declarations: [
        ExpirationSelectorComponent
    ],
    imports: [
        CommonModule,
        DevExtremeModule,
    ],
    exports: [
        ExpirationSelectorComponent
    ]
})
export class ExpirationSelectorModule {
}